








































import { Component, Vue, Watch } from 'vue-property-decorator';
import { myProject  } from '@/api/project/project';
import storage from '@/global/storage'

@Component
export default class AllProject extends Vue {
  private params: object = {
    projectInfo: '',
  };
  private projectList: object[] = [];
  private total: number = 0

  private created() {
    this.getList({});
  }
  private async getList(params){
    try {
      const data:any = await myProject(params);
      this.$nextTick(() => {
        this.projectList = data ? data.rows : []
        this.total = data ? data.total : 0
      })
    }catch(error){
      console.log(error)
    }
  }
  private handleSearch() {
    this.getList(this.params);
  }
  // 跳转项目详情页
  private goDetail(id,title) {
    storage.setSession('lm-project-params', JSON.stringify({ id: id ,title:title,type:'my', name: this.$route.name }))
    this.$router.push({
      name: 'project',
      params: { id: id ,title:title, type:'my'}
    })
  }


}
